<div class="card">
  <app-grid-server-side
    storageKey="individuals"
    [colDefs]="$any(colDefs())"
    [pinFirstColumnName]="pinFirstColumnName"
    [totalRows]="totalRecords()"
    [pageTitle]="pageTitle"
    [serverSideDatasource]="dataSource()"
    [getRowId]="getRowId"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    [defaultExcelExportParams]="excelExportParams"
    [defaultCsvExportParams]="csvExportParams"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    (select)="selectIndividuals($event)"
    (search)="onSearch($event)"
  >
    <div class="grid-controls-middle d-flex justify-content-end gap-12" *appHasRole="['Admin', 'Manager', 'Preparer']">
      <app-button
        text="Merge Individuals"
        [isDisabled]="modalOpened()"
        (clickBtn)="mergeIndividuals()"
      />
    </div>

    <div class="grid-controls-end">
      @if (selectedIndividuals.length) {
        <div
          ngbDropdown
          class="dropdown"
          [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
        >
          <app-button
            ngbDropdownToggle
            id="bulk-actions-dd"
            text="Actions"
            iconClass="icon ic-select-20"
            [iconLast]="true"
            [isDisabled]="modalOpened()"
          />

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
          >
            <button ngbDropdownItem (click)="exportSelectedIndividualsToXls()">
              <span>Export List of Individuals to xlsx</span>
            </button>

<!--            <button ngbDropdownItem (click)="exportSelectedIndividualsToCsv()">-->
<!--              <span>Export to csv</span>-->
<!--            </button>-->

            <button ngbDropdownItem (click)="manageTags()">
              <span>Manage Tags</span>
            </button>
          </div>
        </div>
      }
    </div>
  </app-grid-server-side>
</div>

<app-notes
  [entityType]="EntityType.Individual"
  [individual]="entityForNotes"
  [opened]="notesVisible"
  (close)="notesVisible = false"
/>

<app-alerts-list
  [alerts]="alerts"
  [entityType]="EntityType.Individual"
  [individual]="entityForAlerts"
  [opened]="alertsVisible"
  (close)="onAlertsClose()"
  (alertReaded)="onAlertReaded()"
/>
